export default __webpack_public_path__ + "static/media/SPPL_June_2024.5b5b1d01.pdf";